import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { ProposalOutflowsSectionContainer } from 'Organisms/ProposalOutflowsSection';

const DetailedScenarioSelectionTheNextYearStepTemplate = ({
  resource,
}) => {
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={6} width={'100%'}>
      {resource.withRelationship(
        fr.relationships.proposalYearAheadOutflowSection.name,
        (rel) => (
          <ProposalOutflowsSectionContainer relationship={rel.link('related')} />
        ),
        () => null,
      )}
    </FDStack>
  );
};

DetailedScenarioSelectionTheNextYearStepTemplate.defaultProps = {
};

DetailedScenarioSelectionTheNextYearStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default DetailedScenarioSelectionTheNextYearStepTemplate;
